const WindowSidebar = ({ className, fill = "#606B80" }) => {
  return (
    <svg
      className={className}
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 18.375H3.5C2.5335 18.375 1.75 17.5915 1.75 16.625V4.375C1.75 3.4085 2.5335 2.625 3.5 2.625H17.5C18.4665 2.625 19.25 3.4085 19.25 4.375V16.625C19.25 17.5915 18.4665 18.375 17.5 18.375ZM8.75 6.125V16.625H17.5V6.125H8.75ZM3.5 6.125V16.625H7V6.125H3.5Z"
        fill={fill}
      />
    </svg>
  );
};

const MegaPhone = ({ className = "", fill = "#606B80" }) => {
  return (
    <svg
      className={className}
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.667067 4.15527C0.298668 4.15527 0 4.45394 0 4.82234V10.029C0 10.3974 0.298668 10.6961 0.667067 10.6961C1.03547 10.6961 1.33413 10.3974 1.33413 10.029V4.82234C1.33413 4.45394 1.03547 4.15527 0.667067 4.15527Z"
        fill={fill}
      />
      <path
        d="M14.8025 0.26416H12.0272C11.6588 0.26416 11.3601 0.562829 11.3601 0.931228V1.53381L2.42716 4.18278C2.14397 4.26674 1.94972 4.52699 1.94972 4.82228V10.0265C1.94954 10.0598 1.95275 10.0934 1.95773 10.1272C1.95862 10.1334 1.95951 10.1396 1.96057 10.1457C1.96555 10.1733 1.9716 10.2009 1.98023 10.2283L3.87123 16.2675C3.96053 16.5527 4.22371 16.7354 4.50761 16.7354C4.57352 16.7354 4.64058 16.7255 4.70685 16.7048L7.46059 15.8437C7.62949 15.7909 7.77046 15.6732 7.85247 15.5164C7.93456 15.3597 7.95093 15.1768 7.8981 15.0079L6.961 12.0133L11.36 13.3181V13.9205C11.36 14.2889 11.6587 14.5876 12.0271 14.5876H14.8024C15.1708 14.5876 15.4695 14.2889 15.4695 13.9205V0.931228C15.4696 0.562829 15.1709 0.26416 14.8025 0.26416ZM6.42566 14.7695L4.94512 15.2324L3.62753 11.0245L5.42007 11.5561L6.42566 14.7695ZM6.14398 10.3794C6.14211 10.3789 6.14015 10.3782 6.13828 10.3777L3.28395 9.53106V5.32027L11.3602 2.9254V11.9265L6.14398 10.3794ZM14.1354 13.2536H12.6942V12.8202V2.0318V1.59838H14.1354V13.2536Z"
        fill={fill}
      />
      <path
        d="M20.0086 11.1605L17.1222 9.71702C16.7926 9.55239 16.392 9.68571 16.2272 10.0153C16.0624 10.3449 16.196 10.7455 16.5255 10.9104L19.4119 12.3538C19.5077 12.4017 19.6094 12.4243 19.7098 12.4243C19.9544 12.4243 20.19 12.2892 20.3069 12.0555C20.4716 11.726 20.338 11.3253 20.0086 11.1605Z"
        fill={fill}
      />
      <path
        d="M16.8244 5.20498C16.9246 5.20498 17.0265 5.1823 17.1222 5.13436L20.0086 3.69109C20.3381 3.52628 20.4717 3.12569 20.3069 2.79616C20.1422 2.46662 19.7414 2.33303 19.412 2.49784L16.5255 3.94111C16.196 4.10592 16.0624 4.50652 16.2272 4.83605C16.3441 5.06988 16.5797 5.20498 16.8244 5.20498Z"
        fill={fill}
      />
      <path
        d="M20.3331 6.75879H17.923C17.5546 6.75879 17.2559 7.05746 17.2559 7.42586C17.2559 7.79426 17.5546 8.09292 17.923 8.09292H20.3331C20.7015 8.09292 21.0002 7.79426 21.0002 7.42586C21.0002 7.05737 20.7015 6.75879 20.3331 6.75879Z"
        fill={fill}
      />
    </svg>
  );
};

const User = ({ className = "", fill = "#606B80" }) => (
  <svg
    className={className}
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.375 18.375H2.625V17.5C2.62886 14.1189 5.36886 11.3789 8.75 11.375H12.25C15.6311 11.3789 18.3711 14.1189 18.375 17.5V18.375H16.625V17.5C16.6221 15.085 14.665 13.1279 12.25 13.125H8.75C6.33495 13.1279 4.37789 15.085 4.375 17.5V18.375ZM10.5 10.5C8.08375 10.5 6.125 8.54125 6.125 6.125C6.125 3.70875 8.08375 1.75 10.5 1.75C12.9162 1.75 14.875 3.70875 14.875 6.125C14.8721 8.54005 12.915 10.4971 10.5 10.5ZM10.5 3.5C9.05025 3.5 7.875 4.67525 7.875 6.125C7.875 7.57475 9.05025 8.75 10.5 8.75C11.9497 8.75 13.125 7.57475 13.125 6.125C13.125 4.67525 11.9497 3.5 10.5 3.5Z"
      fill={fill}
    />
  </svg>
);
const Plug = ({ className = "", fill = "#606B80" }) => (
  <svg
    className={className}
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5556 3.93035C19.3963 3.42958 19.1523 2.95987 18.8341 2.54168L21.0002 0.36588L20.0147 -0.619629L17.8389 1.54657C17.4207 1.22799 16.9511 0.983407 16.4503 0.823437C15.3316 0.451668 14.1165 0.494252 13.0266 0.943426C12.4329 1.18897 11.894 1.55007 11.4411 2.00573L8.96936 4.4871L15.8919 11.4113L18.3749 8.93949C18.834 8.48033 19.1876 7.95078 19.4356 7.35243C19.8846 6.26247 19.9272 5.04747 19.5556 3.92875V3.93035ZM18.1333 6.81648C17.9595 7.23874 17.7033 7.62216 17.3798 7.94438L15.8919 9.43224L10.9484 4.4887L12.4362 3.00084C12.7578 2.67688 13.1407 2.42019 13.5625 2.24571C13.99 2.0636 14.4501 1.97067 14.9148 1.97259C15.3794 1.97452 15.8387 2.07126 16.2647 2.25691C16.687 2.43929 17.055 2.69046 17.3686 3.01204C17.6886 3.32401 17.9413 3.69357 18.1237 4.11593C18.3091 4.54165 18.4058 5.00072 18.4077 5.46505C18.4096 5.92939 18.3168 6.38924 18.1349 6.81648H18.1333ZM10.4156 14.8061L12.7898 12.3344L11.8043 11.3393L9.42052 13.8206L6.4448 10.8465L8.83018 8.36354L7.83507 7.37963L5.46249 9.8514L4.47698 8.86749L1.99561 11.3393C1.53828 11.7947 1.17752 12.3378 0.934906 12.9359C0.687757 13.5284 0.561038 14.1642 0.56214 14.8061C0.56214 15.3373 0.642133 15.8556 0.802118 16.358C0.970103 16.854 1.21488 17.3131 1.53645 17.7371L-0.629749 19.9129L0.35416 20.8968L2.52996 18.7322C2.95392 19.0522 3.41308 19.2969 3.90903 19.4649C4.41138 19.6249 4.92974 19.7049 5.46089 19.7049C6.11043 19.7049 6.73437 19.5817 7.33271 19.3337C7.93746 19.0857 8.46861 18.7322 8.92937 18.273L11.4011 15.7901L10.4156 14.8061ZM6.79676 18.0426C6.37377 18.2176 5.92023 18.3068 5.46249 18.305C4.98093 18.305 4.52497 18.2138 4.09461 18.033C3.67999 17.8557 3.30189 17.6029 2.97952 17.2875C2.66478 16.965 2.41255 16.5869 2.23559 16.1724C2.05342 15.7401 1.96089 15.2753 1.96361 14.8061C1.96184 14.3465 2.05176 13.8912 2.22812 13.4668C2.40449 13.0423 2.66374 12.6574 2.99072 12.3344L4.47858 10.8465L9.42212 15.7901L7.93426 17.2779C7.60834 17.6043 7.22199 17.864 6.79676 18.0426Z"
      fill={fill}
    />
  </svg>
);
const CodeBox = ({ className = "", fill = "#606B80" }) => (
  <svg
    className={className}
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5556 3.93035C19.3963 3.42958 19.1523 2.95987 18.8341 2.54168L21.0002 0.36588L20.0147 -0.619629L17.8389 1.54657C17.4207 1.22799 16.9511 0.983407 16.4503 0.823437C15.3316 0.451668 14.1165 0.494252 13.0266 0.943426C12.4329 1.18897 11.894 1.55007 11.4411 2.00573L8.96936 4.4871L15.8919 11.4113L18.3749 8.93949C18.834 8.48033 19.1876 7.95078 19.4356 7.35243C19.8846 6.26247 19.9272 5.04747 19.5556 3.92875V3.93035ZM18.1333 6.81648C17.9595 7.23874 17.7033 7.62216 17.3798 7.94438L15.8919 9.43224L10.9484 4.4887L12.4362 3.00084C12.7578 2.67688 13.1407 2.42019 13.5625 2.24571C13.99 2.0636 14.4501 1.97067 14.9148 1.97259C15.3794 1.97452 15.8387 2.07126 16.2647 2.25691C16.687 2.43929 17.055 2.69046 17.3686 3.01204C17.6886 3.32401 17.9413 3.69357 18.1237 4.11593C18.3091 4.54165 18.4058 5.00072 18.4077 5.46505C18.4096 5.92939 18.3168 6.38924 18.1349 6.81648H18.1333ZM10.4156 14.8061L12.7898 12.3344L11.8043 11.3393L9.42052 13.8206L6.4448 10.8465L8.83018 8.36354L7.83507 7.37963L5.46249 9.8514L4.47698 8.86749L1.99561 11.3393C1.53828 11.7947 1.17752 12.3378 0.934906 12.9359C0.687757 13.5284 0.561038 14.1642 0.56214 14.8061C0.56214 15.3373 0.642133 15.8556 0.802118 16.358C0.970103 16.854 1.21488 17.3131 1.53645 17.7371L-0.629749 19.9129L0.35416 20.8968L2.52996 18.7322C2.95392 19.0522 3.41308 19.2969 3.90903 19.4649C4.41138 19.6249 4.92974 19.7049 5.46089 19.7049C6.11043 19.7049 6.73437 19.5817 7.33271 19.3337C7.93746 19.0857 8.46861 18.7322 8.92937 18.273L11.4011 15.7901L10.4156 14.8061ZM6.79676 18.0426C6.37377 18.2176 5.92023 18.3068 5.46249 18.305C4.98093 18.305 4.52497 18.2138 4.09461 18.033C3.67999 17.8557 3.30189 17.6029 2.97952 17.2875C2.66478 16.965 2.41255 16.5869 2.23559 16.1724C2.05342 15.7401 1.96089 15.2753 1.96361 14.8061C1.96184 14.3465 2.05176 13.8912 2.22812 13.4668C2.40449 13.0423 2.66374 12.6574 2.99072 12.3344L4.47858 10.8465L9.42212 15.7901L7.93426 17.2779C7.60834 17.6043 7.22199 17.864 6.79676 18.0426Z"
      fill={fill}
    />
  </svg>
);

const WindowBox = ({ className = "", fill = "#606B80" }) => (
  <svg
    className={className}
    width="21"
    height="21"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 16.375H2.5C1.5335 16.375 0.75 15.5915 0.75 14.625V2.375C0.75 1.4085 1.5335 0.625 2.5 0.625H16.5C17.4665 0.625 18.25 1.4085 18.25 2.375V14.625C18.25 15.5915 17.4665 16.375 16.5 16.375ZM2.5 4.125V14.625H16.5V4.125H2.5ZM11.8686 12.6186L10.6322 11.3822L12.6378 9.375L10.6314 7.36863L11.8686 6.13138L15.1122 9.375L11.8695 12.6178L11.8686 12.6186ZM7.13138 12.6186L3.88775 9.375L7.13138 6.13138L8.36862 7.36863L6.36225 9.375L8.36775 11.3814L7.13138 12.6178V12.6186Z"
      fill={fill}
    />
  </svg>
);

const Settings = ({ className = "", fill = "#606B80" }) => (
  <svg
    className={className}
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7091_27572)">
      <path
        d="M10.5 13.125C11.9497 13.125 13.125 11.9497 13.125 10.5C13.125 9.05025 11.9497 7.875 10.5 7.875C9.05025 7.875 7.875 9.05025 7.875 10.5C7.875 11.9497 9.05025 13.125 10.5 13.125Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.975 13.125C16.8585 13.3889 16.8238 13.6817 16.8752 13.9655C16.9267 14.2494 17.062 14.5113 17.2637 14.7175L17.3163 14.77C17.479 14.9325 17.608 15.1255 17.6961 15.338C17.7842 15.5504 17.8295 15.7781 17.8295 16.0081C17.8295 16.2381 17.7842 16.4658 17.6961 16.6783C17.608 16.8907 17.479 17.0837 17.3163 17.2462C17.1537 17.409 16.9607 17.538 16.7483 17.6261C16.5358 17.7142 16.3081 17.7595 16.0781 17.7595C15.8481 17.7595 15.6204 17.7142 15.408 17.6261C15.1955 17.538 15.0025 17.409 14.84 17.2462L14.7875 17.1937C14.5813 16.992 14.3194 16.8567 14.0355 16.8052C13.7517 16.7538 13.4589 16.7885 13.195 16.905C12.9362 17.0159 12.7155 17.2001 12.56 17.4348C12.4046 17.6696 12.3211 17.9447 12.32 18.2262V18.375C12.32 18.8391 12.1356 19.2842 11.8074 19.6124C11.4792 19.9406 11.0341 20.125 10.57 20.125C10.1059 20.125 9.66075 19.9406 9.33256 19.6124C9.00437 19.2842 8.82 18.8391 8.82 18.375V18.2962C8.81323 18.0066 8.71948 17.7257 8.55095 17.4901C8.38241 17.2545 8.14689 17.075 7.875 16.975C7.61109 16.8585 7.31833 16.8238 7.03449 16.8752C6.75064 16.9267 6.48872 17.062 6.2825 17.2637L6.23 17.3163C6.06747 17.479 5.87447 17.608 5.66202 17.6961C5.44957 17.7842 5.22185 17.8295 4.99187 17.8295C4.7619 17.8295 4.53418 17.7842 4.32173 17.6961C4.10928 17.608 3.91628 17.479 3.75375 17.3163C3.59104 17.1537 3.46196 16.9607 3.3739 16.7483C3.28583 16.5358 3.2405 16.3081 3.2405 16.0781C3.2405 15.8481 3.28583 15.6204 3.3739 15.408C3.46196 15.1955 3.59104 15.0025 3.75375 14.84L3.80625 14.7875C4.00797 14.5813 4.14329 14.3194 4.19475 14.0355C4.24622 13.7517 4.21148 13.4589 4.095 13.195C3.98408 12.9362 3.79991 12.7155 3.56516 12.56C3.3304 12.4046 3.05531 12.3211 2.77375 12.32H2.625C2.16087 12.32 1.71575 12.1356 1.38756 11.8074C1.05937 11.4792 0.875 11.0341 0.875 10.57C0.875 10.1059 1.05937 9.66075 1.38756 9.33256C1.71575 9.00437 2.16087 8.82 2.625 8.82H2.70375C2.99337 8.81323 3.27425 8.71948 3.50989 8.55095C3.74552 8.38241 3.925 8.14689 4.025 7.875C4.14148 7.61109 4.17622 7.31833 4.12475 7.03449C4.07329 6.75064 3.93797 6.48872 3.73625 6.2825L3.68375 6.23C3.52104 6.06747 3.39196 5.87447 3.3039 5.66202C3.21583 5.44957 3.1705 5.22185 3.1705 4.99187C3.1705 4.7619 3.21583 4.53418 3.3039 4.32173C3.39196 4.10928 3.52104 3.91628 3.68375 3.75375C3.84628 3.59104 4.03928 3.46196 4.25173 3.3739C4.46418 3.28583 4.6919 3.2405 4.92188 3.2405C5.15185 3.2405 5.37957 3.28583 5.59202 3.3739C5.80447 3.46196 5.99747 3.59104 6.16 3.75375L6.2125 3.80625C6.41872 4.00797 6.68064 4.14329 6.96448 4.19475C7.24833 4.24622 7.54109 4.21148 7.805 4.095H7.875C8.1338 3.98408 8.35451 3.79991 8.50998 3.56516C8.66545 3.3304 8.74888 3.05531 8.75 2.77375V2.625C8.75 2.16087 8.93437 1.71575 9.26256 1.38756C9.59075 1.05937 10.0359 0.875 10.5 0.875C10.9641 0.875 11.4092 1.05937 11.7374 1.38756C12.0656 1.71575 12.25 2.16087 12.25 2.625V2.70375C12.2511 2.98531 12.3346 3.2604 12.49 3.49516C12.6455 3.72991 12.8662 3.91408 13.125 4.025C13.3889 4.14148 13.6817 4.17622 13.9655 4.12475C14.2494 4.07329 14.5113 3.93797 14.7175 3.73625L14.77 3.68375C14.9325 3.52104 15.1255 3.39196 15.338 3.3039C15.5504 3.21583 15.7781 3.1705 16.0081 3.1705C16.2381 3.1705 16.4658 3.21583 16.6783 3.3039C16.8907 3.39196 17.0837 3.52104 17.2462 3.68375C17.409 3.84628 17.538 4.03928 17.6261 4.25173C17.7142 4.46418 17.7595 4.6919 17.7595 4.92188C17.7595 5.15185 17.7142 5.37957 17.6261 5.59202C17.538 5.80447 17.409 5.99747 17.2462 6.16L17.1937 6.2125C16.992 6.41872 16.8567 6.68064 16.8052 6.96448C16.7538 7.24833 16.7885 7.54109 16.905 7.805V7.875C17.0159 8.1338 17.2001 8.35451 17.4348 8.50998C17.6696 8.66545 17.9447 8.74888 18.2262 8.75H18.375C18.8391 8.75 19.2842 8.93437 19.6124 9.26256C19.9406 9.59075 20.125 10.0359 20.125 10.5C20.125 10.9641 19.9406 11.4092 19.6124 11.7374C19.2842 12.0656 18.8391 12.25 18.375 12.25H18.2962C18.0147 12.2511 17.7396 12.3346 17.5048 12.49C17.2701 12.6455 17.0859 12.8662 16.975 13.125V13.125Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7091_27572">
        <rect width="21" height="21" fill={fill} />
      </clipPath>
    </defs>
  </svg>
);

const Close = ({ className = "", fill = "#F7F7F7" }) => (
  <svg
    className={className}
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.5 1.5L10 10" stroke={fill} strokeWidth="1.5" />
    <path d="M10 1.5L1.5 10" stroke={fill} strokeWidth="1.5" />
  </svg>
);
const Envelope = ({ className = "" }) => (
  <svg
    className={className}
    width="22"
    height="17"
    viewBox="0 0 22 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 0.529297H19C20.1 0.529297 21 1.4293 21 2.5293V14.5293C21 15.6293 20.1 16.5293 19 16.5293H3C1.9 16.5293 1 15.6293 1 14.5293V2.5293C1 1.4293 1.9 0.529297 3 0.529297Z"
      fill="#28265B"
    />
    <path
      d="M21 2.5293L11 9.5293L1 2.5293"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const Bell = ({ className = "", show_ball = false }) => (
  <svg
    className={className}
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 8.5293C18 6.938 17.3679 5.41187 16.2426 4.28666C15.1174 3.16144 13.5913 2.5293 12 2.5293C10.4087 2.5293 8.88258 3.16144 7.75736 4.28666C6.63214 5.41187 6 6.938 6 8.5293C6 15.5293 3 17.5293 3 17.5293H21C21 17.5293 18 15.5293 18 8.5293Z"
      fill="#28265B"
    />
    <path
      d="M13.73 21.5293C13.5542 21.8324 13.3018 22.0839 12.9982 22.2588C12.6946 22.4337 12.3504 22.5258 12 22.5258C11.6496 22.5258 11.3054 22.4337 11.0018 22.2588C10.6981 22.0839 10.4458 21.8324 10.27 21.5293"
      stroke="#28265B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {show_ball && (
      <circle cx="17.7015" cy="5.22782" r="3.97196" fill="#EC5627" />
    )}
  </svg>
);

const WindowCodeBlock = ({ className = "", fill = "#606B80" }) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.75 15.75H1.75C0.783502 15.75 0 14.9665 0 14V1.75C0 0.783502 0.783502 0 1.75 0H15.75C16.7165 0 17.5 0.783502 17.5 1.75V14C17.5 14.9665 16.7165 15.75 15.75 15.75ZM1.75 3.5V14H15.75V3.5H1.75Z"
      fill={fill}
    />
    <path
      d="M13.4691 4.05127C12.4826 4.05127 11.3811 4.58655 10.2044 5.64383C9.43467 6.32951 8.7711 7.1081 8.29776 7.723C8.06486 7.66451 7.82567 7.63479 7.58553 7.63452C6.83501 7.63569 6.11556 7.93436 5.58485 8.46506C5.05415 8.99576 4.75549 9.71521 4.75432 10.4657C4.75432 11.7309 4.12172 12.306 4.06863 12.3547C3.98162 12.4212 3.91771 12.5133 3.88596 12.6181C3.8542 12.7229 3.85621 12.835 3.89168 12.9386C3.92799 13.0443 3.9967 13.1358 4.08804 13.2001C4.17939 13.2645 4.2887 13.2984 4.40042 13.297H7.58553C8.33606 13.2958 9.05551 12.9971 9.58621 12.4664C10.1169 11.9357 10.4156 11.2163 10.4167 10.4657C10.4165 10.2256 10.3868 9.98641 10.3283 9.75351C10.9432 9.28017 11.7218 8.6166 12.4074 7.84686C13.4647 6.67014 14 5.56862 14 4.58212C14 4.44133 13.9441 4.30631 13.8445 4.20675C13.745 4.1072 13.6099 4.05127 13.4691 4.05127ZM7.58553 12.2352H5.43116C5.69173 11.6821 5.82332 11.0771 5.81602 10.4657C5.81602 10.1158 5.9198 9.77364 6.11424 9.48265C6.30868 9.19166 6.58504 8.96485 6.90837 8.83092C7.23171 8.69699 7.5875 8.66195 7.93075 8.73023C8.274 8.79851 8.58929 8.96704 8.83676 9.21451C9.08423 9.46198 9.25276 9.77727 9.32104 10.1205C9.38932 10.4638 9.35427 10.8196 9.22034 11.1429C9.08641 11.4662 8.85961 11.7426 8.56862 11.937C8.27762 12.1315 7.93551 12.2352 7.58553 12.2352ZM9.27541 8.19634C9.40813 8.02824 9.56296 7.84244 9.72664 7.6478C9.98066 7.83991 10.2069 8.06619 10.3991 8.32021C10.2044 8.49274 10.0186 8.64314 9.85493 8.77586C9.69157 8.55501 9.49626 8.3597 9.27541 8.19634ZM11.1821 7.59913C10.9672 7.32896 10.7223 7.08408 10.4521 6.86921C10.6025 6.7188 10.753 6.57282 10.9122 6.43126C11.6067 5.81193 12.257 5.40052 12.8321 5.21915C12.58 6.03754 11.8943 6.88691 11.1821 7.59913Z"
      fill={fill}
    />
  </svg>
);

export {
  MegaPhone,
  WindowSidebar,
  User,
  Plug,
  CodeBox,
  Close,
  Envelope,
  Bell,
  WindowCodeBlock,
  WindowBox,
  Settings,
};
